var map = {
	"./arrow-down.svg": 61,
	"./arrow-left.svg": 2310,
	"./burger.svg": 8470,
	"./close.svg": 2271,
	"./copy.svg": 3066,
	"./download.svg": 6665,
	"./edit.svg": 7249,
	"./email.svg": 5415,
	"./facebook.svg": 3961,
	"./fullscreen.svg": 6594,
	"./instagram.svg": 9355,
	"./logo-full.svg": 7342,
	"./logo-tiny.svg": 3011,
	"./logo.svg": 9312,
	"./magnifier.svg": 6415,
	"./more.svg": 5606,
	"./share.svg": 6498,
	"./star.svg": 9137,
	"./twitter.svg": 6342,
	"./wm.svg": 1133,
	"./zoom-in.svg": 2860,
	"./zoom-out.svg": 3315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6046;